import React, { useEffect, useState } from 'react';

import { useDebouncedCallback } from 'use-debounce';

import { Card, Loading } from '@components/common';
import { useRecruitingRequest } from '@components/StudiesApp/components/StudyDraft/hooks/useRecruitingRequest';
import { ExternalCandidatesRequestForm } from '@components/StudiesApp/components/StudyPublished/pages/ExternalCandidatesRequest/components/ExternalCandidatesRequestForm';
import { SingleUserSVG } from '@components/svgs';

import { CardHeader } from './CardHeader';

interface Props {
  study: Study;
  request: ExternalCandidatesRequest;
}

export const AudienceCard: React.FC<Props> = ({ study, request: initialRequest }) => {
  const {
    request: fetchedRequest,
    refetchRequest,
    handleChange
  } = useRecruitingRequest({
    study: study,
    requestId: initialRequest.id
  });

  const [request, setRequest] = useState<ExternalCandidatesRequest>();

  const { callback: debouncedHandleChange } = useDebouncedCallback(handleChange, 1000);

  useEffect(() => {
    if (fetchedRequest) setRequest(fetchedRequest);
  }, [fetchedRequest]);

  if (!request) return <Loading absolute />;

  return (
    <Card noPadding>
      <div className='p-6'>
        <CardHeader icon={<SingleUserSVG />} title='Audience' />
        <ExternalCandidatesRequestForm
          study={study}
          request={request}
          refetchRequest={refetchRequest}
          sidebar={false}
          generalSection={false}
          onChange={debouncedHandleChange}
        />
      </div>
    </Card>
  );
};
